import { render } from "./CoursesIcon.vue?vue&type=template&id=431675f8&scoped=true"
import script from "./CoursesIcon.vue?vue&type=script&lang=js"
export * from "./CoursesIcon.vue?vue&type=script&lang=js"

import "./CoursesIcon.vue?vue&type=style&index=0&id=431675f8&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431675f8"]])

export default __exports__